const LoadMessages = [
    { title: "Starting...", label: "Fetching and processing product page may take 1 to 2 minutes" },
    { title: "Fetching page...", label: "" },
    { title: "Extracting page content...", label: "" },
    { title: "Generating product info...", label: "" },
    { title: "Completing...", label: "" },
];

export default LoadMessages;